import { BarrelData } from "../../model/Barrel";

function isUserMemberOfBarrel(barrel: BarrelData | null | undefined, userId: string | null | undefined): boolean {
    if (!barrel || !userId) {
        return false;
    }

    return barrel.users.some(({ user: { _id } }) => userId === _id);
}

export default isUserMemberOfBarrel;
